module.exports = __webpack_public_path__ + "static/media/undraw_message_sent_1030.5808c737.svg";